import React from 'react';
import { Link } from 'react-router-dom';
import { modelClass } from '/imports/api/sets';
import { ModelListPage } from '/imports/ui/ModelListPage';
import { useUser } from '/imports/hooks';

export const CardSetsPage = () => (
  <ModelListPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    columns={[
      { field: '_id', label: 'ID', render: (set) => <Link to={`${modelClass.pathPrefix}/${set._id}`}>{String(set._id)}</Link> },
      { field: 'name', label: 'Code' },
      {
        field: 'gbBuyMargin', label: 'Buy Margin',
        render: (set) => ((set as any).gbBuyMargin ?? null) !== null
          ? `${(set as any).gbBuyMargin > 0 ? '+' : ''}${(set as any).gbBuyMargin}%`
          : <span className="text-fg-3">tiers</span>,
      },
      {
        field: 'gbSellMargin', label: 'Sell Margin',
        render: (set) => ((set as any).gbSellMargin ?? null) !== null
          ? `${(set as any).gbSellMargin > 0 ? '+' : ''}${(set as any).gbSellMargin}%`
          : <span className="text-fg-3">default</span>,
      },
    ]}
  />
);

// keep unused import live so tree-shaking doesn't drop the hook
void useUser;
